import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Tabs from "../../CommonComponents/Tabs";
import Filters from "./Filterbtn";
import Table from "./Table";
import Pagination from "./Pagination";

const MainContent = ({ reload }) => {
  const location = useLocation();
  const [filters, setFilters] = useState({
    date: "",
    currency: "",
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTP] = useState(0);

  useEffect(() => {
    setFilters({
      date: "",
      currency: "",
    });
    setPage(1);
  }, [location.pathname]);

  return (
    <div className="container-fluid main-content-table bgColor d-flex flex-column overflow-hidden mt-2">
      <div className="flex-grow-1 d-flex flex-column pt-2">
        <Filters filters={filters} setFilters={setFilters} />
        <div className="table-wrapper  flex-grow-1 p-3 rounded shadow-sm d-flex flex-column">
          <div className="table-container scroll flex-grow-1 table-scroll-container">
            <Table
              reload={reload}
              filters={filters}
              page={page}
              setPage={setPage}
              setTotalPages={setTP}
            />
          </div>
          <div className="d-flex justify-content-end mt-5 me-3">
            <Pagination totalPages={totalPages} page={page} setPage={setPage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
